<span class="loading-button__content" [class.loading-button__content--hidden]="loading">
  <ng-content></ng-content>
</span>

<span class="loading-button__spinner" *ngIf="loading" aria-hidden="true" data-testid="loading-button-spinner"></span>
